import React, { useState } from "react";
import PayoutsTable from "../components-bootstrap/PayoutsTable";
import PaginationModified from "../../data/PaginationModified";

const PaymentLinkTable = ({
  tableData,
  tableColumns,
  tablePagination,
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  isCustPagi,
  isFirstColSticky,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState("10");
  const [customItemsPerPage, setCustomItemsPerPage] = useState(10);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems =
    tableData?.length > 0
      ? tableData?.slice(indexOfFirstItem, indexOfLastItem)
      : [];

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = tableData
    ? Math.ceil(tableData?.length / itemsPerPage)
    : 0;

  const handleItemsPerPageChange = (e) => {
    const { value } = e.target;
    setCustomItemsPerPage(value);
  };

  const applyCustomItemsPerPage = () => {
    if (customItemsPerPage !== "") {
      setItemsPerPage(parseInt(customItemsPerPage));
    }
  };

  function getPagination() {
    try {
      const pagination = tablePagination ? tablePagination : [];
      return pagination;
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="fullWidthFlexCenter">
      {isCustPagi ? (
        <>
          {tableData?.length !== 0 && (
            <div className="customTablePaginationContainer customInputLimit">
              <button
                className={`prev-next-btn prev-btn ${
                  currentPage === 1 ? "disabled-btn" : ""
                }`}
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-compact-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M9.224 1.553a.5.5 0 0 1 .223.67L6.56 8l2.888 5.776a.5.5 0 1 1-.894.448l-3-6a.5.5 0 0 1 0-.448l3-6a.5.5 0 0 1 .67-.223"
                  />
                </svg>
              </button>
              <span>{`Page ${currentPage} of ${totalPages} (Total ${tableData?.length} Data)`}</span>
              <button
                className="prev-next-btn next-btn"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-chevron-compact-right"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671"
                  />
                </svg>
              </button>
              <div className="custom-inuts">
                <input
                  className="custom-no"
                  type="number"
                  value={customItemsPerPage}
                  onChange={handleItemsPerPageChange}
                  placeholder="Enter items per page"
                />
                <button className="apply-btn" onClick={applyCustomItemsPerPage}>
                  Apply
                </button>
              </div>
            </div>
          )}
        </>
      ) : null}

      <div className="customTableContainer">
        <PayoutsTable
          dataValues={
            isCustPagi
              ? currentItems
              : Array.isArray(tableData)
              ? tableData
              : []
          }
          columnsValues={Array.isArray(tableColumns) ? tableColumns : [{}]}
          isFirstColSticky={isFirstColSticky}
        />
      </div>

      {isPage || setIsPage || tablePagination ? (
        <div className="customTablePaginationContainer">
          <PaginationModified
            isPage={isPage}
            onChangePage={setIsPage}
            pagination={getPagination()}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
          />
        </div>
      ) : null}
    </div>
  );
};

export default PaymentLinkTable;
